import {
  AktivitetTypeWithVejledning,
  AnvendelsesOmraade,
  GuideAktivitetPunkt,
  GuideOverpunkt,
  GuidePunkt,
  OverListepunkt,
} from 'src/app/api/models';
import { ListePunktBase } from 'src/app/api/models/liste-punkt-base';

export class HierarchyItem {
  id: string;
  title: string;
  description: string;
  prioritet: number;
  expanded: boolean;
  showInfoIcon: boolean;
  subItems: HierarchyItem[] = [];
  itemRef: any;
  header: number;

  constructor() {}

  static fromGuidePunkt(guidePunkt: GuidePunkt): HierarchyItem {
    const item = new HierarchyItem();

    if (!!guidePunkt) {
      item.id = guidePunkt.id;
      item.title = guidePunkt.visningNavn;
      item.description = guidePunkt.vejledningContent.kortVejledningText;
      item.prioritet = guidePunkt.prioritet;
      item.expanded = false;
      item.showInfoIcon = guidePunkt.vejledningContent.hasLangVejledning;
      item.itemRef = guidePunkt;

      if (guidePunkt.type === 'GuideOverpunkt') {
        const guideOverPunkt = guidePunkt as GuideOverpunkt;
        item.subItems = guideOverPunkt.underPunkter.map(guideUnderPunkt =>
          HierarchyItem.fromGuidePunkt(guideUnderPunkt)
        );
      }

      if (guidePunkt.type === 'GuideAktivitetPunkt') {
        const guideAktivitetPunkt = guidePunkt as GuideAktivitetPunkt;
        item.id = guideAktivitetPunkt.aktivitet.aktivitetTypeReference.id;
      }
    }

    return item;
  }

  static fromListePunkt(listePunkt: ListePunktBase): HierarchyItem {
    const item = new HierarchyItem();

    if (listePunkt) {
      item.id = listePunkt.kode;
      item.title = `${listePunkt.visningKode}. ${listePunkt.visningNavn}`;
      item.description = listePunkt.vejledningContent.kortVejledningText;
      item.prioritet = listePunkt.prioritet;
      item.expanded = false;
      item.showInfoIcon = listePunkt.vejledningContent.hasLangVejledning;
      item.itemRef = listePunkt;

      if (listePunkt.type === 'OverListepunkt') {
        const overListePunkt = listePunkt as OverListepunkt;
        item.subItems = overListePunkt.underPunkter.map(underPunkt =>
          HierarchyItem.fromListePunkt(underPunkt)
        );
      }
    }

    return item;
  }
  static fromAktivitetsTypeWithVejledning(aktivitet: AktivitetTypeWithVejledning): HierarchyItem {
    const item = new HierarchyItem();
    if (aktivitet) {
      item.id = aktivitet.aktivitetTypeReference.id;
      item.title = aktivitet.navn;
      item.expanded = true;
      if (aktivitet.vejledningContent) {
        item.description = aktivitet.vejledningContent.kortVejledningText;
        item.showInfoIcon = aktivitet.vejledningContent.hasLangVejledning;
      }
      item.itemRef = aktivitet;
    }
    return item;
  }

  static fromAnvendelsesOmraade(anvendelsesOmraade: AnvendelsesOmraade) {
    return {
      title: anvendelsesOmraade.visningNavn,
      description: anvendelsesOmraade.vejledningContent.kortVejledningText,
      id: anvendelsesOmraade.kode,
      expanded: true,
      itemRef: anvendelsesOmraade,
      prioritet: anvendelsesOmraade.prioritet,
      showInfoIcon: anvendelsesOmraade.vejledningContent.hasLangVejledning,
      subItems: [],
    } as HierarchyItem;
  }
}
